module.exports = __webpack_public_path__ + "assets/img/btn-application-glay.602eba02.svg";